import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import TournamentStandings from './TournamentStandings';

// Публичная страница для экспорта standings (без Layout и аутентификации)
// Доступна только локально (localhost) для использования через Puppeteer
// Использует компонент TournamentStandings, но в режиме экспорта (без селекторов)

const StandingsExport: React.FC = () => {
  const { tournamentId, level } = useParams<{ tournamentId: string; level: string }>();
  const [isLocalhost, setIsLocalhost] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Проверяем, что мы на localhost или на рабочем домене
    const hostname = window.location.hostname;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname === 'ttm.bogslevel.com';
    setIsLocalhost(isLocal);
    setMounted(true);
  }, []);

  // Если не localhost, показываем ошибку
  if (!isLocalhost && mounted) {
    return (
      <div style={{ padding: '20px', background: 'white', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ color: 'red', fontSize: '18px' }}>Доступ запрещен. Эта страница доступна только локально.</div>
      </div>
    );
  }

  if (!tournamentId || !level || !mounted) {
    return (
      <div style={{ padding: '20px', background: 'white', minHeight: '100vh' }}>
        <div>Загрузка...</div>
      </div>
    );
  }

  // Передаем параметры через props для надежности.
  // ВАЖНО: повторяем контейнер ширины страницы /tournament-standings,
  // чтобы геометрия плей-офф в экспорте совпадала с браузерной.
  return (
    <div style={{ margin: '0', background: '#f9fafb' }}>
      <main style={{ maxWidth: '1600px', margin: '0 auto', padding: '24px 8px' }}>
        <TournamentStandings 
          exportTournamentId={tournamentId}
          exportLevel={level ? decodeURIComponent(level) : undefined}
        />
      </main>
    </div>
  );
};

export default StandingsExport;
